<template>
  <v-layout row wrap white justify-left align-end>
    <v-flex xs6 px-4>
      <v-autocomplete
        ref="condominiumCbo"
        clearable
        v-model="condominium_id"
        :items="condominiums"
        item-text="name_fantasy"
        item-value="condominium_id"
        label="Selecione o condomínio"
        chips
      >
        <template v-slot:selection="data">
          <v-chip
            :selected="data.selected"
          >
            <v-avatar>
              <img :src="data.item.avatar" />
            </v-avatar>
            {{ data.item.name_fantasy }}
          </v-chip>
        </template>

        <template v-slot:item="data">
          <template v-if="checkType(data)">
            <v-list-tile-content v-text="data.item"></v-list-tile-content>
          </template>
          <template v-else>
            <v-list-tile-avatar>
              <img :src="data.item.avatar" />
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title
                v-html="data.item.name_fantasy"
              ></v-list-tile-title>
              <v-list-tile-sub-title
                v-html="data.item.name_company"
              ></v-list-tile-sub-title>
            </v-list-tile-content>
          </template>
        </template>
      </v-autocomplete>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  name: 'SearchCondominium',

  props: {
    getContractStatus: Function,
    changeTitle: Function,
    getAccountabilityData: Function
  },

  data () {
    return {
      condominiums: [],
      condominium_id: null,
    }
  },

  mounted () {
    this.getComdominiums()
  },

  watch: {
    condominium_id(value) {
      if (value) this.$emit('selectedCondominium', value)
    }
  },

  methods: {
    checkType (data) {
      return typeof data.item !== 'object'
    },

    getComdominiums () {
      let obj = {
        url: '/api/get_list',
        query: '',
        method: 'get',
        noLoader: true
      }
      this.$store.dispatch('request/doRequest', obj).then((response) => {
        this.condominiums = response.data
        let obj = { condominiums: response.data }
        this.$store.commit('condominiums/updateCondominiumList', obj)
        this.$props.condominiums = response.data
      })
    },
  }
}
</script>

<style>
.icn-spinner {
  animation: spin-animation 0.5s infinite;
  display: inline-block;
}

@keyframes spin-animation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(359deg);
  }
}
</style>
